import {CloseOutlined, MenuOutlined} from '@ant-design/icons';
import {Avatar, Button, Divider, Drawer} from 'antd';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const DrawerMenu = ({items = []}) => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const showDrawer = () => {
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const handleNavigate = path => {
    navigate(path);
    closeDrawer();
  };

  return (
    <>
      {/* Mobile menu button */}
      <Button
        type={'text'}
        icon={<MenuOutlined />}
        onClick={showDrawer}
        className={'text-xl text-primary-700'}
      />

      <Drawer
        title={'Menu'}
        placement={'left'}
        open={open}
        onClose={closeDrawer}
        closable
        closeIcon={<CloseOutlined />}
        size={'default'}
        className={'bg-primary-950'}
        styles={{
          header: {
            backgroundColor: '#020617',
            color: '#d4af37',
            borderBottom: '1px solid #334155',
          },
          body: {
            backgroundColor: '#020617',
            padding: 0,
          },
        }}
      >
        <div className={'flex flex-col h-full bg-primary-950'}>

          {/* Menu items */}
          <div className={'flex-1 overflow-y-auto'}>

            {items.map((item, index) => {
              const isSelected =
                location.pathname === item.path ||
                location.pathname.startsWith(`${item.path}/`);

              return (
                <React.Fragment key={item.key || item.path}>

                  <button
                    type={'button'}
                    onClick={() => handleNavigate(item.path)}
                    className={`
                      w-full
                      flex
                      items-center
                      gap-3
                      px-5
                      py-4
                      text-left
                      text-lg
                      transition-colors
                      ${
                isSelected
                  ? 'bg-primary-700 text-gold'
                  : 'bg-primary-950 text-gold hover:bg-primary-700'
                }
                    `}
                  >
                    <span className={'flex items-center justify-center'}>
                      {item.icon}
                    </span>

                    <span className={'flex-1'}>
                      {item.label}
                    </span>
                  </button>

                  {index !== items.length - 1 && (
                    <Divider className={'my-0 border-primary-800'} />
                  )}

                </React.Fragment>
              );
            })}

          </div>

        </div>
      </Drawer>
    </>
  );
};

DrawerMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node,
      path: PropTypes.string.isRequired,
      icon: PropTypes.node,
    }),
  ),
};

export default DrawerMenu;
